import debug from 'debug';
import DictionaryObject from 'Global/Shared/Components/Sitecore/DictionaryObject';
import Breakpoints from 'Minetilbud/Shared/Components/Breakpoints/Breakpoints';
import basketSvg from 'Minetilbud/Shared/Icons/fk_basket_circle.svg';
import favouritesSvg from 'Minetilbud/Shared/Icons/icon_filter_favorite.svg';

const log = debug('FrontPageCatalogs:Templates:ActiveCustomersTemplates');
const breakpoints = new Breakpoints();

class ActiveCustomersTemplates {

	constructor() {
		this.dictionary = new DictionaryObject({
			dictionaryUrl: 'Forum_dk/AdvertUI/MtCustomerCatalogs',
			includeDescendants: false
		});
	}

	/**
	 * @param {Obejct} customer 
	 */
	 activeCustomerContainer(customer) {
		return `
			<li class="o-front-page-catalogs-customer__container" data-key="${customer.id}">
				<a href="${this.activeCustomerUrl(customer)}" class="o-front-page-catalogs-customer__container-link" data-event="catalog-link" title="${customer.name}"></a>
			</li>
		`;
	}

	/**
	 * @param {Obejct} customer 
	 */
	 activeCustomerContent(customer) {
		return `
			<div class="o-front-page-catalogs-customer__image-wrapper" data-js="image-wrapper"></div>
			<div class="o-front-page-catalogs-customer__info-wrapper">
				<div class="o-front-page-catalogs-customer__name" data-event="customer-link" data-url="${customer.customerUrl}">${customer.name}</div>
				${this.activeCustomerInfo(customer)}
				${this.activeCustomerFeatures(customer)}
			</div>
		`;
	}

	/**
	 * @param {Obejct} customer 
	 */
	activeCustomerFeatures(customer) {
		return `
			<div class="o-front-page-catalogs-customer__features">
				<div class="o-front-page-catalogs-customer__favourite ${customer.isFavorite ? 'is-active' : ''}" data-event="favorite-toggle" data-id="${customer.id}" data-name="${customer.name}">${favouritesSvg}</div>
				<div class="o-front-page-catalogs-customer__online ${customer.isOnline ? 'is-active' : ''}" data-js="CustomerCatalogsOnline">${basketSvg}</div>
			</div>
		`;
	}

	/**
	 * @param {Obejct} customer 
	 */
	activeCustomerInfo(customer) {
		const paperCatalogs = customer.catalogs.filter(catalog => catalog.isFeed === false);

		if (paperCatalogs.length > 1) {
			return `<div class="o-front-page-catalogs-customer__info">${paperCatalogs.length} ${this.dictionary.Text('catalogsLabel')}</div>`;
		} else if (customer.isFeed && paperCatalogs.length === 0) {
			return '<div class="o-front-page-catalogs-customer__info"></div>';
		}

		return `<div class="o-front-page-catalogs-customer__info">${this.dateFormat(paperCatalogs[0].validFrom)}-${this.dateFormat(paperCatalogs[0].validTo)}</div>`;
	}

	/**
	 * @param {Obejct} customer 
	 */
	activeCustomerUrl(customer) {
		const numberOfPaperCatalogs = customer.catalogs.filter(catalog => catalog.isFeed === false).length;

		if (numberOfPaperCatalogs > 1 || customer.isFeed) return customer.customerUrl;

		return customer.customerUrl + '/1';
	}

	dateFormat(data) {
		let date = new Date(data);
		let day = date.getDate();
		let month = date.getMonth() + 1;
		return `${day > 9 ? day : '0' + day}.${month > 9 ? month : '0' + month}`;
	}

	dictionaryInit() {
		return this.dictionary.Get();
	}
}

export default ActiveCustomersTemplates;
